import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';
import { reportCloseFilter, reportOpenFilter } from 'analytics/reporters';
import { Dispatch } from 'react';

export interface MobileState {
  activeWidget: string | null;
  mobileFiltersSheetVisible: boolean;
}

const initialState: MobileState = {
  activeWidget: null,
  mobileFiltersSheetVisible: false
};

// Complicated actions

export const showMobileFiltersSheet = (status: boolean) => (
  dispatch: Dispatch<any>,
  getState: () => RootState
) => {
  const state = getState();
  const selectedGroupId = state.products.selectedGroupId;

  if (status) {
    reportOpenFilter({ menu: selectedGroupId });
  } else {
    reportCloseFilter({ menu: selectedGroupId });
  }
  dispatch(toggleFilter(status));
};

// Reducer and actions

const mobileSlice = createSlice({
  name: 'mobile',
  initialState,
  reducers: {
    setActiveWidget(state, action: PayloadAction<string | null>) {
      state.activeWidget = action.payload;
    },
    toggleFilter(state, action: PayloadAction<boolean>) {
      state.mobileFiltersSheetVisible = action.payload;
    }
  }
});

// Selectors

export const getActiveWidget = (state: RootState) => state.mobile.activeWidget;
export const isMobileFiltersSheetVisible = (state: RootState) =>
  state.mobile.mobileFiltersSheetVisible;

// Exports

export const { setActiveWidget, toggleFilter } = mobileSlice.actions;

export default mobileSlice.reducer;
